import Vue from 'vue'
//import {firebaseApp} from './firebaseApp'
import App from './App.vue'
import VueRouter from 'vue-router'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

//Import Components
import Signup from './components/Signup.vue'
import Signin from './components/Signin.vue'
import AdminDashboard from './components/admin/AdminDashboard.vue'
import AddCommunity from './components/admin/AddCommunity.vue'
import AddAdministrator from './components/admin/AddAdministrator.vue'
import MemberRequests from './components/admin/MemberRequestsList.vue'
import HouseholdProfile from './components/members/HouseholdProfile.vue'
import CommunityProfile from './components/admin/CommunityProfile.vue'
import VisitorsLog from './components/admin/VisitorsLog.vue'
import GuestsLog from './components/VisitorsSheet.vue'
import ActiveVisitors from './components/ActiveVisitors.vue'
import Announcements from './components/members/Announcements/Announcements.vue'
import NoPermissions from "./components/members/NoPermissions.vue"
import Suggestions from "./components/members/Suggetions/Suggestions.vue"
import ContactUs from "./components/members/ContactUs.vue"
import Projects from "./components/members/Projects/Projects.vue"
import ProjectProfile from "./components/members/Projects/ProjectProfile.vue"

//import store
import store from './store'

Vue.config.productionTip = false

/* Router configuration */
const router = new VueRouter({
  mode: 'history',
  routes: [{
    path: '/addcommunity/',
    component: AddCommunity,
    name: "Add Community",
    icon: 'fas fa-home'
  },
  {
    path: '/addadmin/',
    component: AddAdministrator,
    name: "Add Administrator",
    icon: 'fas fa-add'
  },
  {
    path: '/signup/',
    component: Signup,
    name: "Sign Up",
    icon: 'fas fa-user-plus'
  },
  {
    path: '/signin/',
    component: Signin,
    name: "Sign In",
    icon: 'fas fa-user'
  },
  {
    path: '/admin/',
    component: AdminDashboard,
    name: "Admin",
    icon: 'fas fa-key'
  },
  {
    path: '/requests/',
    component: MemberRequests,
    name: "Member Requests",
    icon: 'fas fa-users'
  },
  {
    path: '/household/',
    component: HouseholdProfile,
    name: "My Home",
    icon: 'fas fa-home'
  },
  {
    path: '/community/:id',
    component: CommunityProfile,
    name: "My Community",
    icon: 'volunteer_activism'
  },
  {
    path: '/visitorslog/',
    component: VisitorsLog,
    name: "Visitors Log",
    icon: 'list_alt'
  },
  {
    path: '/guestslog/',
    component: GuestsLog,
    name: "Guests Log",
    icon: 'list_alt'
  },
  {
    path: '/activevisitors/',
    component: ActiveVisitors,
    name: "Active Visitors",
    icon: 'list_alt'
  },
  {
    path: '/announcements/',
    component: Announcements,
    name: "Announcements",
    icon: 'announcement'
  },
  {
    path: '/nopermissions/',
    component: NoPermissions,
    name: "No Permissions",
    icon: 'frown'
  },
  {
    path: '/suggestions/',
    component: Suggestions,
    name: "Suggestion Box",
    icon: 'how_to_vote'
  },
  {
    path: '/contactus/',
    component: ContactUs,
    name: "Contact Us",
    icon: 'info'
  },
  {
    path: '/projects/',
    component: Projects,
    name: "Projects",
    icon: 'favorite_border'
  },
  {
    path: '/project/:id',
    component: ProjectProfile,
    name: "Project",
    icon: 'volunteer_activism'
  },
  ]
})


Vue.use(VueRouter)

/* Vuetify */
new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')